import { html } from "https://cdn.jsdelivr.net/npm/lit-element@4.1.1/+esm";
import { SelectField } from "./fields.js";

export class SelectFromAPIField extends SelectField {
	static properties = {
		...SelectField.properties,
		apiUrl: { type: String, attribute: "api-url" },
		nullOptionText: { type: String, attribute: "null-option-text" },
		nullOptionValue: { type: String, attribute: "null-option-value" },
		discardLegalForm: { type: Boolean, attribute: "discard-legal-form" },
	};

	constructor() {
		super();
		this.nullOptionText = "Select an option";
		this.nullOptionValue = "";
		this.optionsFromAPI = [];
		this.discardLegalForm = false;
	}
	
	static #adjustProtocol (urlString){
		const url = new URL (urlString);
		url.protocol = window.location.protocol;
		return url.toString ();
	}

	async firstUpdated () {
		super.firstUpdated ();
		if (this.apiUrl)
			await this.fetchOptionsFromAPI();
	}

	async fetchOptionsFromAPI() {
		const response = await fetch(SelectFromAPIField.#adjustProtocol (this.apiUrl));
		if (!response.ok)
			throw new Error(`Error from API: ${response.statusText}`);

		const data = await response.json();
		this.optionsFromAPI = data.map((item) => ({
			value: item.value,
			label: item.name,
		}));
		this.requestUpdate ();
	}
	
	render () {
	    const optionsStatic = Array.from (this.shadowRoot.querySelectorAll ("option-component"));
	    const optionsDynamic = this.optionsFromAPI;
		
	    const options = [
	      { value: this.nullOptionValue, label: this.nullOptionText },
	      ...optionsStatic.map((option) => ({
	        value: option.value,
	        label: option.label,
	      })),
	      ...optionsDynamic,
	    ];
		
	    return html`
	      <div class="row align-items-center">
	        <label for="${this.idInput}" class="col-sm-3 col-form-label text-end">
	          ${this.label}
	        </label>
	        <div class="col-sm-9">
	          <select
	            id="${this.idInput}"
	            name="${this.name}"
	            .value="${this.value}"
	            @change="${this.handleChange}"
	            ?required=${this.required}
	          >
	            ${options.map(
	              (option) => html`<option value="${option.value}" ?selected="${this.value === option.value}">${option.label}</option>`
	            )}
	          </select>
	        </div>
	      </div>
	    `;
	}
	
	willUpdate (changedProperties){
		if (changedProperties.has ("value") && !this.value)
			this.value = changedProperties.get ("value");
	}
	
	setValues (values){
		super.setValues (values);
		this.value = values.value;
	}
	
	handleChange(event) {
		this.value = event.target.value;
		this.dispatchChangeEvent();
	}
	
	getValues (){
		const optionsStatic = Array.from (this.shadowRoot.querySelectorAll ("option-component"));
		const optionsDynamic = this.optionsFromAPI;

		const options = [
		  { value: this.nullOptionValue, label: this.nullOptionText },
		  ...optionsStatic.map((option) => ({
		    value: option.value,
		    label: option.label,
		  })),
		  ...optionsDynamic,
		];
		
		const selected = options.find (option => this.value === option.value);
		const optionValue = selected ? selected.label : "";
		const result = {"name" : this.name, "value" : this.value, ... super.getValues ()};
		result ["optionValue"] = optionValue;
		if (this.discardLegalForm) {
			result["discard-legal-form"] = "true";
		}
		return result;
	}

}

customElements.define("select-from-api", SelectFromAPIField);
